export const maskPhone = (phone: string = '', maskWith: string = 'X') => {
  if (!phone?.length) {
    return phone;
  }
  const phoneLength = phone.length;

  const lastTwoDigit = phone.substring(phoneLength - 2);
  const initialSubstring = phone.substring(0, phoneLength - 10);

  return `${initialSubstring}${'00000000'.replaceAll('0', maskWith)}${lastTwoDigit}`;
};
